import React from "react";
import { Phone, Clock, ShieldCheck, Star } from "lucide-react";

const PHONE = "01.84.16.20.60";
const PHONE_TEL = "tel:+33184162060";
const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/43781dee-f402-4763-b282-7ff328abc859/images/faaa4c975a1e20f9086ddcac618e32d6b4e9ad386c56912b414efa0fa02899a3.png";

export const Hero = ({ city }) => {
  const titleCity = city || "93";
  return (
    <section className="relative overflow-hidden bg-[#0F172A] text-white">
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage: `url(${HERO_BG})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0F172A]/80 via-[#0F172A]/85 to-[#0F172A]" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-28 lg:py-32">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-7">
            <div className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-[#FF5A1F] mb-5">
              Urgence Plomberie · 24h/24 · 7j/7
            </div>
            <h1
              className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black tracking-tighter leading-[0.95] mb-6"
              style={{ fontFamily: "'Cabinet Grotesk','Manrope', sans-serif" }}
            >
              Débouchage canalisation{" "}
              <span className="text-[#FF5A1F]">{titleCity}</span>
              <br />
              <span className="text-white/80 font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-6xl">
                au 01.84.16.20.60
              </span>
            </h1>
            <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-2xl mb-8 leading-relaxed">
              Évacuation bouchée, WC engorgé, dégorgement d'urgence : nos plombiers
              interviennent en <strong className="text-white">moins de 30 minutes</strong>{" "}
              chez vous, à tarif clair et garanti.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 mb-10">
              <a
                href={PHONE_TEL}
                data-testid="hero-call-btn"
                className="inline-flex items-center justify-center gap-3 bg-[#FF5A1F] hover:bg-[#E04812] text-white font-black text-lg px-8 py-5 rounded-full shadow-xl transition-all hover:-translate-y-1"
              >
                <Phone className="w-5 h-5" strokeWidth={3} />
                Appeler le {PHONE}
              </a>
              <a
                href="#devis"
                data-testid="hero-quote-btn"
                className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white hover:bg-white/10 font-bold px-8 py-5 rounded-full transition"
              >
                Devis gratuit
              </a>
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 text-sm">
              {[
                { Icon: Clock, label: "30 min", sub: "Intervention" },
                { Icon: ShieldCheck, label: "Garantie", sub: "3 mois" },
                { Icon: Star, label: "4.9/5", sub: "Avis Google" },
                { Icon: Phone, label: "24/7", sub: "Astreinte" },
              ].map(({ Icon, label, sub }, i) => (
                <div
                  key={i}
                  className="bg-white/5 border border-white/10 rounded-xl p-3 backdrop-blur"
                >
                  <Icon className="w-5 h-5 text-[#FF5A1F] mb-2" />
                  <div className="font-extrabold text-white">{label}</div>
                  <div className="text-xs text-white/60">{sub}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="bg-white/5 border border-white/15 rounded-2xl p-6 backdrop-blur-xl">
              <div className="text-xs uppercase tracking-[0.25em] text-[#FF5A1F] font-bold mb-3">
                Demander une intervention
              </div>
              <h3 className="text-2xl font-extrabold mb-4">
                Un plombier près de chez vous, maintenant.
              </h3>
              <ul className="space-y-3 text-white/85 mb-6 text-sm">
                {[
                  "Diagnostic offert avant intervention",
                  "Devis ferme et transparent",
                  "Pas de majoration nuit & week-end",
                  "Travail garanti 3 mois",
                ].map((t, i) => (
                  <li key={i} className="flex items-start gap-3">
                    <span className="mt-1 w-2 h-2 rounded-full bg-[#FF5A1F] shrink-0" />
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
              <a
                href={PHONE_TEL}
                className="block w-full text-center bg-[#FF5A1F] hover:bg-[#E04812] text-white font-black py-4 rounded-xl transition"
                data-testid="hero-card-call-btn"
              >
                {PHONE}
              </a>
              <p className="text-xs text-white/60 text-center mt-3">
                Disponible 24h/24 et 7j/7, jours fériés inclus
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
